class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
      const endlessCollection = new Ajaxinate({
  container: '#product-grid',
  pagination: '.infinite_next',
  });
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  
     var minimumwidth = parseFloat(document.getElementById("Filter-option-minwidth").value);
    var maximumwidth = parseFloat(document.getElementById("Filter-option-maxwidth").value);
    if( minimumwidth >= 0 && maximumwidth >0 ){
    document.getElementById('minimumWidthV').innerHTML= minimumwidth;
    document.getElementById('maximumWidthV').innerHTML= maximumwidth;
    $("#widthRange").fadeIn();
    }
  var minimumlength = parseFloat(document.getElementById("Filter-option-minlength").value);
    var maximumlength = parseFloat(document.getElementById("Filter-option-maxlength").value);
    if(maximumlength >0 && minimumlength >= 0 ){
    document.getElementById('minimumLengthV').innerHTML= minimumlength;
    document.getElementById('maximumLengthV').innerHTML= maximumlength;
    $("#lengthRange").fadeIn();
    }
      var minimumweight = parseFloat(document.getElementById("Filter-option-minweight").value);
    var maximumweight = parseFloat(document.getElementById("Filter-option-maxweight").value);
    if(minimumweight >= 0 && maximumweight > 0 ){
    document.getElementById('minimumWeightV').innerHTML= minimumweight;
    document.getElementById('maximumWeightV').innerHTML= maximumweight;
    $("#weightRange").fadeIn();
    }
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    let lengthminimum = new  URLSearchParams(formData).toString();
    var vars = [], hash;
    var hashes = lengthminimum.split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
       
         var keying = hash[0];
      if (keying.indexOf('length') !== -1){
         vars.push(parseInt(hash[1]));
        // vars[hash[0]] = hash[1];
      }
    }
    if(vars.length > 1){
    var myDiv = document.querySelector('#lengthdata');
    var idslist = myDiv.dataset.lenghtlist;
    const idslist2 = idslist.split(',');
    var minimumlength = parseFloat(document.getElementById("Filter-option-minlength").value);
    var maximumlength = parseFloat(document.getElementById("Filter-option-maxlength").value);
     for (i = 0; i < idslist2.length; i++)
       {
         var parsedFloatdata =parseFloat(idslist2[i]);
         if(parsedFloatdata > minimumlength  && parsedFloatdata < maximumlength ){
            lengthminimum = lengthminimum.concat("&filter.v.option.length=",idslist2[i]);
           
         }
       }
    }
    if(vars.length > 1){
    var myDiv2 = document.querySelector('#widthdata');
    var idslist22 = myDiv2.dataset.lenghtlist;
    const idslist2 = idslist22.split(',');   
    var minimumwidth = parseFloat(document.getElementById("Filter-option-minwidth").value);
    var maximumwidth = parseFloat(document.getElementById("Filter-option-maxwidth").value);
     for (i = 0; i < idslist2.length; i++)
       {
         var parsedFloatdata =parseFloat(idslist2[i]);
         if(parsedFloatdata > minimumwidth && parsedFloatdata < maximumwidth ){
          lengthminimum = lengthminimum.concat("&filter.v.option.width=",idslist2[i]);
           
         }
       }
    }
        if(vars.length > 1){
    var myDiv3 = document.querySelector('#weightdata');
    var idslist33 = myDiv3.dataset.lenghtlist;
    console.log({idslist33});
    const idslist3 = idslist33.split(',');        
    var minimumweight = parseFloat(document.getElementById("Filter-option-minweight").value);
    var maximumweight = parseFloat(document.getElementById("Filter-option-maxweight").value);
     for (i = 0; i < idslist3.length; i++)
       {
         var parsedFloatdata =parseFloat(idslist3[i]);
       
         if(parsedFloatdata > minimumweight && parsedFloatdata < maximumweight){
          lengthminimum = lengthminimum.concat("&filter.p.m.specs.totweight=",idslist3[i]);
           
         }
       }
    }
    // return new URLSearchParams(formData).toString();
    return lengthminimum;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const params = new URLSearchParams(url);
    params.toString();
    
    console.log(event.currentTarget.parentElement.id);
    const parentID= event.currentTarget.parentElement.id;
    if(parentID == 'weightRange'){
      params.delete('filter.p.m.specs.totweight');
      document.getElementById("Filter-option-minweight").value ='';
       document.getElementById("Filter-option-maxweight").value ='';
      $("#weightRange").fadeOut();
    }
        if(parentID == 'weightRange2'){
      params.delete('filter.p.m.specs.totweight');
      document.getElementById("Filter-option-minweight").value ='';
       document.getElementById("Filter-option-maxweight").value ='';
      $("#weightRange").fadeOut();
    }
    if(parentID == 'widthRange'){
      params.delete('filter.v.option.width');
       document.getElementById("Filter-option-minwidth").value ='';
       document.getElementById("Filter-option-maxwidth").value ='';
      $("#widthRange").fadeOut();
    }
    if(parentID == 'widthRange2'){
      params.delete('filter.v.option.width');
      document.getElementById("Filter-option-minwidth").value ='';
       document.getElementById("Filter-option-maxwidth").value ='';
      $("#widthRange").fadeOut();
    }
     if(parentID == 'lengthRange'){
      params.delete('filter.v.option.length');
       document.getElementById("Filter-option-minlength").value ='';
       document.getElementById("Filter-option-maxlength").value ='';
      $("#lengthRange").fadeOut();
    }
    if(parentID == 'lengthRange2'){
      params.delete('filter.v.option.length');
        document.getElementById("Filter-option-minlength").value ='';
       document.getElementById("Filter-option-maxlength").value ='';
      $("#lengthRange").fadeOut();
    }
    if(parentID == 'removeAll'){
      params.delete('filter.v.option.width');
      params.delete('filter.v.option.length');
      params.delete('filter.v.option.width');
      document.getElementById("Filter-option-minlength").value ='';
      document.getElementById("Filter-option-maxlength").value ='';
      document.getElementById("Filter-option-minwidth").value ='';
      document.getElementById("Filter-option-maxwidth").value ='';
      document.getElementById("Filter-option-minweight").value ='';
      document.getElementById("Filter-option-maxweight").value ='';
    }
    
    
    url=params.toString();
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    //window.location.href = "https://danielatest1.myshopify.com/collections/all-stones";
  }
}

customElements.define('facet-remove', FacetRemove);
